/*
 * Author: Roger
 * File Created: Monday, 24-08-05 06:11 pm
 * Last Modified: Friday, 24-09-13 11:43 am, by Dw
 */

import { keyframes, styled, Typography } from '@mui/material';

const blink = keyframes`
  0% {
    opacity: 1
  }
  50% {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

export const StyledTypingText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '44px',
  fontWeight: 700,
  lineHeight: '120%',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  [`&::after`]: {
    content: '""',
    display: 'inline-block',
    width: '6px',
    height: '54px',
    background: '#FFF',
    animation: `${blink} .8s infinite`,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '120%',
    [`&::after`]: {
      width: '3px',
      height: '33px',
    },
  },
}));
